import React from 'react';
import classNames from 'classnames';

import css from './IconIroningStreamlineTabler.module.css';

/**
 * IconIroningStreamlineTabler icon.
 *
 * @component
 * @param {Object} props
 * @param {string?} props.className add more style rules in addition to components own css.root
 * @param {string?} props.rootClassName overwrite components own css.root
 * @returns {JSX.Element} SVG icon
 */
const IconIroningStreamlineTabler = props => {
  const { rootClassName, className } = props;
  const classes = classNames(rootClassName || css.root, className);

  return (
<svg className={classes} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M16.459 5C17.4059 5.00016 18.3219 5.3362 19.0443 5.94833C19.7667 6.56047 20.2485 7.40901 20.404 8.343L20.981 11.807L21.791 16.672C21.8386 16.9583 21.8233 17.2515 21.7462 17.5313C21.6691 17.8111 21.532 18.0708 21.3445 18.2923C21.1569 18.5138 20.9234 18.6919 20.6602 18.8141C20.3969 18.9363 20.1102 18.9997 19.82 19H3C2.73478 19 2.48043 18.8946 2.29289 18.7071C2.10536 18.5196 2 18.2652 2 18C2 15.8783 2.84285 13.8434 4.34315 12.3431C5.84344 10.8429 7.87827 10 10 10H18.652L18.432 8.671C18.3588 8.23136 18.1409 7.82877 17.8128 7.52712C17.4847 7.22548 17.0652 7.04207 16.621 7.006L16.459 7H9C8.73478 7 8.48043 6.89464 8.29289 6.70711C8.10536 6.51957 8 6.26522 8 6C8 5.73478 8.10536 5.48043 8.29289 5.29289C8.48043 5.10536 8.73478 5 9 5H16.459Z" fill="#262338"/>
</svg>

  );
};

export default IconIroningStreamlineTabler;
